"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DEFAULT_NAME = void 0;
var DEFAULT_NAME = '_hw';
/**
 * Represents a model that is created in embedded script
 * as part of script initialization.
 */

exports.DEFAULT_NAME = DEFAULT_NAME;

/**
 * Loads widget instance.
 *
 * @param win Global window object which stores pre-loaded and post-loaded state of widget instance.
 * @param defaultConfig A configurations that are merged with user.
 * @param scriptElement The script tag that includes installation script and triggered loader.
 * @param render A method to be called once initialization done and DOM element for hosting widget is ready.
 */
var _default = function _default(win, defaultConfig, scriptElement, render) {
  var _scriptElement$attrib, _scriptElement$attrib2;

  // get a hold of script tag instance, which has an
  // attribute `id` with unique identifier of the widget instance
  var instanceName = (_scriptElement$attrib = scriptElement === null || scriptElement === void 0 ? void 0 : (_scriptElement$attrib2 = scriptElement.attributes.getNamedItem('id')) === null || _scriptElement$attrib2 === void 0 ? void 0 : _scriptElement$attrib2.value) !== null && _scriptElement$attrib !== void 0 ? _scriptElement$attrib : DEFAULT_NAME;
  var loaderObject = win[instanceName];

  if (!loaderObject || !loaderObject.q) {
    throw new Error("Widget didn't find LoaderObject for instance [".concat(instanceName, "]. ") + "The loading script was either modified, no call to 'init' method was done " + "or there is conflicting object defined in `window.".concat(instanceName, "` ."));
  } // check that the widget is not loaded twice under the same name


  if (win["loaded-".concat(instanceName)]) {
    throw new Error("Widget with name [".concat(instanceName, "] was already loaded. ") + "This means you have multiple instances with same identifier (e.g. '".concat(DEFAULT_NAME, "')"));
  } // this will an root element of the widget instance


  var targetElement; // iterate over all methods that were called up until now

  for (var i = 0; i < loaderObject.q.length; i++) {
    var item = loaderObject.q[i];
    var methodName = item[0];

    if (i === 0 && methodName !== 'init') {
      throw new Error("Failed to start Widget [".concat(instanceName, "]. 'init' must be called before other methods."));
    } else if (i !== 0 && methodName === 'init') {
      continue;
    }

    var loadedObject = Object.assign(defaultConfig, item[1]); // the actual rendering of the widget

    if (scriptElement && scriptElement.parentNode) {
      targetElement = win.document.createElement('div');
      scriptElement.parentNode.insertBefore(targetElement, scriptElement);
    } else {
      var _ref;

      // old safe code
      var wrappingElement = (_ref = loadedObject.element) !== null && _ref !== void 0 ? _ref : win.document.body;
      targetElement = wrappingElement.appendChild(win.document.createElement('div'));
    }

    switch (methodName) {
      case 'init':
        if (loadedObject.debug) {
          console.log("Starting widget [".concat(instanceName, "]"), loadedObject);
        }

        targetElement.setAttribute('id', "widget-".concat(instanceName));
        render(targetElement, loadedObject); // store indication that widget instance was initialized

        win["loaded-".concat(instanceName)] = true;
        break;
      // TODO: here you can handle additional async interactions
      // with the widget from page (e.q. `_hw('refreshStats')`)

      default:
        console.warn("Unsupported method [".concat(methodName, "]"), item[1]);
    }
  } // once finished processing all async calls, we going
  // to convert LoaderObject into sync calls to methods


  win[instanceName] = function (method) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    switch (method) {
      case 'event':
        {
          var _targetElement;

          (_targetElement = targetElement) === null || _targetElement === void 0 ? void 0 : _targetElement.dispatchEvent(new CustomEvent('widget-event', {
            detail: {
              name: args === null || args === void 0 ? void 0 : args[0]
            }
          }));
          break;
        }

      default:
        console.warn("Unsupported method [".concat(method, "]"), args);
    }
  };
};

exports["default"] = _default;